"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJssEditingSecret = exports.handleEditorFastRefresh = exports.getPublicUrl = void 0;
const chalk_1 = __importDefault(require("chalk"));
const utils_1 = require("@sitecore-jss/sitecore-jss/utils");
/**
 * Get the publicUrl.
 * This is used primarily to enable compatibility with Sitecore editors.
 * This is set to http://localhost:3000 by default.
 * VERCEL_URL is provided by Vercel in case if we are in Preview deployment (deployment based on the custom branch),
 * preview deployment has unique url, we don't know exact url.
 * Similarly, DEPLOY_URL is provided by Netlify and would give us the deploy URL
 */
const getPublicUrl = () => {
    if (process.env.NETLIFY && process.env.DEPLOY_URL)
        return process.env.DEPLOY_URL;
    if (process.env.VERCEL_URL)
        return `https://${process.env.VERCEL_URL}`;
    let url = process.env.PUBLIC_URL;
    if (url === undefined) {
        console.warn(`${chalk_1.default.yellow.bold('Warning:')} An PUBLIC_URL environment variable is not defined. Falling back to http://localhost:3000.`);
        url = 'http://localhost:3000';
    }
    else {
        try {
            new URL(url);
        }
        catch (error) {
            throw new Error(`The PUBLIC_URL environment variable '${url}' is not a valid URL.`);
        }
    }
    // Ensure no trailing slash
    return url.toString().replace(/\/$/, '');
};
exports.getPublicUrl = getPublicUrl;
/**
 * Since Sitecore editors do not support Fast Refresh:
 * 1. Subscribe on events provided by webpack.
 * 2. Reset editor chromes when build is finished
 * @param {boolean} [forceReload] force page reload instead of reset chromes
 * @default forceReload false
 */
const handleEditorFastRefresh = (forceReload = false) => {
    if (process.env.NODE_ENV !== 'development' || !(0, utils_1.isEditorActive)()) {
        // Only run if development mode and editor is active
        return;
    }
    const eventSource = new window.EventSource(`${(0, exports.getPublicUrl)()}/_next/webpack-hmr`);
    window.addEventListener('beforeunload', () => eventSource.close());
    eventSource.onopen = () => console.log('[Sitecore Editor Fast Refresh Listener] Online');
    eventSource.onmessage = (event) => {
        if (event.data.indexOf('{') === -1)
            return; // heartbeat
        const payload = JSON.parse(event.data);
        console.debug(`[Sitecore Editor Fast Refresh Listener] Saw event: ${JSON.stringify(payload)}`);
        if (payload.action !== 'built')
            return;
        if (forceReload)
            return window.location.reload();
        setTimeout(() => {
            console.log('[Sitecore Editor HMR Listener] Sitecore editor does not support Fast Refresh, reloading chromes...');
            (0, utils_1.resetEditorChromes)();
        }, 500);
    };
};
exports.handleEditorFastRefresh = handleEditorFastRefresh;
const getJssEditingSecret = () => {
    const secret = process.env.JSS_EDITING_SECRET;
    if (!secret || secret.length === 0) {
        throw new Error('The JSS_EDITING_SECRET environment variable is missing or invalid.');
    }
    return secret;
};
exports.getJssEditingSecret = getJssEditingSecret;
